;(function ($, mat_theme) {

    /**
     * Notes on the strangeness of all this...
     * so, they kept asking for different mechanisms to operate the menu.  So
     * there is a great deal of crufty circuitous mechanisms here.  Hopefully, though
     * it will seem clear enough when we revisit it.
     *
     * Sorry, future-self or other folks... I know this code sucks but we need
     * to get er out the door.
     *
     */

    const TOGGLE_BUTTON_SELECTOR = '#main_menu_toggle';
    const MENU_CONTAINER_SELECTOR = '#main_menu_container';
    const BREAKPOINT = mat_theme.main_menu_breakpoint;

    let menu_state_mobile_is_active = false;
    let menu_state_desktop_is_active = false;

    /**
     * HELPERS
     */

    const toggle_mobile_nav = () => {

        $(MENU_CONTAINER_SELECTOR).toggleClass('closed');

        if ($(MENU_CONTAINER_SELECTOR).hasClass('closed')) {
            $(TOGGLE_BUTTON_SELECTOR).removeClass('open');
            $(TOGGLE_BUTTON_SELECTOR).focus();
            $(TOGGLE_BUTTON_SELECTOR).attr('aria-expanded', false);
            $(TOGGLE_BUTTON_SELECTOR).attr('aria-label', "open main menu");
            $(MENU_CONTAINER_SELECTOR + ' .menu-item').removeClass('open');
        } else {
            $(TOGGLE_BUTTON_SELECTOR).addClass('open');
            $(TOGGLE_BUTTON_SELECTOR).attr('aria-expanded', true);
            $(TOGGLE_BUTTON_SELECTOR).attr('aria-label', "close main menu");
        }
    };

    const reset_aria = () => {
        if (menu_state_mobile_is_active) {
            $(MENU_CONTAINER_SELECTOR + " .menu-item-has-children > a").attr('aria-haspopup', true);
            $(MENU_CONTAINER_SELECTOR + " .menu-item-has-children > a").attr('aria-expanded', false);
        } else {
            $(MENU_CONTAINER_SELECTOR + " .menu-item-has-children > .top-level-menu-toggle").attr('aria-haspopup', true);
            $(MENU_CONTAINER_SELECTOR + " .menu-item-has-children > .top-level-menu-toggle").attr('aria-expanded', false);
        }
    };

    /**
     * Main Logic
     */

    const addSetup_mobile = () => {

        if (menu_state_mobile_is_active) return;
        menu_state_mobile_is_active = true;

        reset_aria();

        // add links to parent items in sub-nav menu
        $(`.menu-item-has-children > a`)
            .each(function (index) {

                if ('#' == $(this).attr('href')) return true;
                if ('header_search_area_toggle' == this.id) return true;

                const text = $(this).text();
                const url = $(this).attr('href');
                const link = `<li class="menu-item link-added-for-mobile"><a href="${url}">${text}</a></li>`;

                $(this)
                    .closest('.menu-item-has-children')
                    .find('.menu-item')
                    .first()
                    .before(link);

                $(this).addClass('modified-for-mobile');
                $(this).attr('data-desktop-url', url);
                $(this).attr('href', '#');

            });

        $(TOGGLE_BUTTON_SELECTOR).on('click', function (ev) {
            toggle_mobile_nav();
        });

        $(TOGGLE_BUTTON_SELECTOR).on('keypress', function (ev) {
            if (ev.which == 9) toggle_mobile_nav();
        });

        $(MENU_CONTAINER_SELECTOR).on('click', 'a', function (ev) {

            // if it isn't a submenu, do the link nav
            if ('#' != $(this).attr('href')) return true;
            ev.preventDefault();

            $(this).closest('.menu-item').toggleClass('open');
            $(this).focus();  // cause yeah, the a should be focused on click, but Safari doesn't do that.

            const parent_tree = $( document.activeElement ).parents('.menu-item.open');
            $(MENU_CONTAINER_SELECTOR + " .menu-item").removeClass('open');
            reset_aria();
            $(parent_tree).addClass('open');

            if ($(this).closest('.menu-item').hasClass('open')) {
                $(this).attr('aria-expanded', true);
                $( document.activeElement )
                    .parents('.menu-item')
                    .children("a")
                    .attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }

        });

    };

    // clean up any functionality for the mobile menu:
    const clearSetup_mobile = () => {
        if (!menu_state_mobile_is_active) return;
        menu_state_mobile_is_active = false;
        $(TOGGLE_BUTTON_SELECTOR).off();
        $(MENU_CONTAINER_SELECTOR).off();

        // clean up links to parent items in sub-nav menu
        $(MENU_CONTAINER_SELECTOR + ' .link-added-for-mobile').remove();
        $(MENU_CONTAINER_SELECTOR + ' .modified-for-mobile').each(function (index) {
            const url = $(this).data('desktop-url');
            $(this).attr('href', url);
        });

    };

    const addSetup_desktop = () => {

        if (menu_state_desktop_is_active) return;
        menu_state_desktop_is_active = true;

        $(MENU_CONTAINER_SELECTOR).on('mouseenter mouseleave', '.menu-item', function (ev) {
            $(MENU_CONTAINER_SELECTOR + " .menu-item").removeClass('menu-open');
            $(MENU_CONTAINER_SELECTOR + " .top-level-menu-toggle").attr('aria-expanded', false);
            $(this).children('.top-level-menu-toggle').attr('aria-expanded', true);
        });

        $(`${MENU_CONTAINER_SELECTOR} .main-menu .menu-item-has-children > a`)
            .each(function (index) {
                if ('header_search_area_toggle' != this.id) {
                    const text = $(this).text();
                    $(this).after(
                        `<button href="#" class="top-level-menu-toggle" aria-haspopup="true" aria-expanded="false"><span class="screen-reader-text">Show submenu for ${text}</span></button>`
                    );
                }
            });

        // sets up some keyboard controls for the desktop nav menu
        $(MENU_CONTAINER_SELECTOR).on('click', '.top-level-menu-toggle', function (ev) {
            if (
                '#' !== $(this).attr('href')
                || 'header_search_area_toggle' === $(this).attr('id')
                || ev.which === 9
            ) return true;
            ev.preventDefault();

            if($(this).closest(".menu-item").hasClass('menu-open')) {
                $(this).closest(".menu-item").removeClass('menu-open');
                $(this).closest(".menu-item > .top-level-menu-toggle").attr('aria-expanded', false);
            } else if ($(this).closest(".menu-item").length) {
                $(this).closest(".menu-item").addClass('menu-open');
                $(this).closest(".menu-item > .top-level-menu-toggle").attr('aria-expanded', true);
                const submenu = $(this).closest('.menu-item').find(".sub-menu");
                if (!submenu.length) return true;
                if (Box.ImNotTouchingYou($(submenu), null, true)) return;
                    $(submenu).addClass('left-dropdown');
            }

        });

        // clean up the sub menus when keyboard navigating
        $(MENU_CONTAINER_SELECTOR).on('focusin', function (ev) {
            const parent_tree = $( document.activeElement ).parents('.menu-open');
            $(MENU_CONTAINER_SELECTOR + " .menu-item").removeClass('menu-open');
            reset_aria();
            $(parent_tree).addClass('menu-open');
            $(parent_tree).children('.top-level-menu-toggle').attr('aria-expanded', true);
        });


        $(MENU_CONTAINER_SELECTOR + " .main-menu > ul > li > .top-level-menu-toggle").on('focusin', function (ev) {
            if ($(this).closest(".menu-open").length) {
                $(this).closest(".menu-open > .top-level-menu-toggle").attr('aria-expanded', false);
                $(this).closest(".menu-open").removeClass('menu-open');
            }
        });

    };

    const clearSetup_desktop = () => {

        if (!menu_state_desktop_is_active) return;
        menu_state_desktop_is_active = false;

        $(MENU_CONTAINER_SELECTOR).off();
        $(MENU_CONTAINER_SELECTOR + " .menu-item").removeClass('menu-open');
        $(MENU_CONTAINER_SELECTOR + " .sub-menu").removeClass('left-dropdown');

        $(MENU_CONTAINER_SELECTOR + " .top-level-menu-toggle").remove();

    };

    const window_resize_action = () => {
        if (window.innerWidth >= BREAKPOINT) {
            clearSetup_mobile();
            addSetup_desktop();
        } else {
            clearSetup_desktop();
            addSetup_mobile();
        }
    };

    window_resize_action();
    window.addEventListener("resize", window_resize_action);

})(jQuery, mat_theme);